export default `{
	pafiMenu (identifier: "menu") {
		content
	}
}`;
